module.exports = __webpack_public_path__ + "static/img/logo-dark.d2cc60b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-dark.png
// module id = ja13
// module chunks = 1